// extracted by mini-css-extract-plugin
export default {"tableContainer":"styles_tableContainer__Lay9b","flexWrap":"styles_flexWrap__7xpB+"};